if (!("classList" in document.documentElement)) {
    Object.defineProperty(HTMLElement.prototype, 'classList', {
        get: function () {
            var self = this;
            function update(fn) {
                return function (value) {
                    var classes = self.className.split(/\s+/g),
                        index = classes.indexOf(value);

                    fn(classes, index, value);
                    self.className = classes.join(" ");
                }
            }

            return {
                add: update(function (classes, index, value) {
                    if (!~index) classes.push(value);
                }),

                remove: update(function (classes, index) {
                    if (~index) classes.splice(index, 1);
                }),

                toggle: update(function (classes, index, value) {
                    if (~index)
                        classes.splice(index, 1);
                    else
                        classes.push(value);
                }),

                contains: function (value) {
                    return !!~self.className.split(/\s+/g).indexOf(value);
                },

                item: function (i) {
                    return self.className.split(/\s+/g)[i] || null;
                }
            };
        }
    });
}
import '@babel/polyfill'
import Vue from 'vue'
import "classlist-polyfill"
import App from './App.vue'
import router from './router'
import store from "./store/store.js"
import axios from 'axios'
import VueAxios from 'vue-axios'
import '../public/css/reset.css'
import "./assets/common.scss";
import MyPlugin from './utils/utils'
import "./utils/datetime.js";
// import moment from 'moment/moment'
// import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import MintUI from 'mint-ui'
// import 'mint-ui/lib/style.css'
// import './eleconfig/element-var.scss'
import i18n from './locales'

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
import MetaInfo from "vue-meta-info";
Vue.use(MetaInfo);
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}
// 切换路由添加google统计
router.afterEach(function(to) {
    if (window.ga) {
    window.ga("set", "page", to.fullPath); // 你可能想根据请求参数添加其他参数，可以修改这里的 to.fullPath
    window.ga("send", "pageview");
    }
});

// Vue.filter('formatDate', function (value, formatString) {
//     if (!value) {
//         return value
//     } else {
//         formatString = formatString || 'YYYY-MM-DD HH:MM';
//         // return moment(value).format(formatString); // value可以是普通日期 20170723
//         return moment(value).format(formatString)
//     }

// });

import {
  Form,
  FormItem,
  Checkbox,
  CheckboxGroup,
  Input,
  Select,
  Option,
  InputNumber,
  Row,
  Col,
  Upload,
  Message,
  DatePicker,
  Steps,
  Step,
  Button,
  MessageBox,
	Carousel,
	CarouselItem,
	Rate,
} from "element-ui";

Vue.use(Form);
Vue.use(Button);
Vue.use(FormItem);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(InputNumber);
Vue.use(Row);
Vue.use(Col);
Vue.use(DatePicker);
Vue.use(Upload);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Rate);

import VueAwesomeSwiper from "vue-awesome-swiper";
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm;

// Vue.use(ElementUI);
// Vue.use(MintUI);
Vue.use(router)
// axios.defaults.withCredentials=true
Vue.use(VueAxios, axios)
Vue.use(MyPlugin)
Vue.config.productionTip = false

new Vue({
    render: (h) => h(App),
    router,
    i18n,
    store, //使用store
}).$mount("#app");
